module.exports = __webpack_public_path__ + "img/battery-orange.5be31265.svg";